import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, UserLicenseModel, removeSubscriptionUser } from 'store/account/subscription';

export function useRemoveSubscriptionUser(): Operation<
	(userId: string, licenseModel: UserLicenseModel) => void
> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.REMOVE_SUBSCRIPTION_USER);

	function handler(userId: string, licenseModel: UserLicenseModel) {
		dispatch(removeSubscriptionUser(userId, licenseModel));
	}

	return [{ loading, error }, handler];
}
